import { render, staticRenderFns } from "./TherapyDashboard.vue?vue&type=template&id=4d6b1d14"
import script from "./TherapyDashboard.vue?vue&type=script&lang=js"
export * from "./TherapyDashboard.vue?vue&type=script&lang=js"
import style0 from "./TherapyDashboard.vue?vue&type=style&index=0&id=4d6b1d14&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports